import { render, staticRenderFns } from "./VechileModelTable.vue?vue&type=template&id=1880e908&"
import script from "./VechileModelTable.vue?vue&type=script&lang=js&"
export * from "./VechileModelTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports